<script>
import Chart from 'chart.js'
import { Pie } from 'vue-chartjs'
import { settingsColors } from '@/assets/chartsSettings.js'

Chart.pluginService.register({
  beforeDraw: function(chart) {
    if (chart.config.options.elements.center) {
      //Get ctx from string
      const ctx = chart.chart.ctx

      //Get options from the center object in options
      const centerConfig = chart.config.options.elements.center
      const fontStyle = centerConfig.fontStyle || 'Arial'
      const txt = centerConfig.text
      const color = centerConfig.color || '#000'
      const sidePadding = centerConfig.sidePadding || 20
      const sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2)
      //Start with a base font of 30px
      ctx.font = '40px ' + fontStyle

      //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
      const stringWidth = ctx.measureText(txt).width
      const elementWidth = chart.innerRadius * 2 - sidePaddingCalculated

      // Find out how much the font can grow in width.
      const widthRatio = elementWidth / stringWidth
      const newFontSize = Math.floor(30 * widthRatio)
      const elementHeight = chart.innerRadius * 2

      // Pick a new font size so it will not be larger than the height of label.
      const fontSizeToUse = Math.min(newFontSize, elementHeight)

      //Set font settings to draw it correctly.
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      const centerX = (chart.chartArea.left + chart.chartArea.right) / 2
      const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2
      ctx.font = fontSizeToUse + 'px ' + fontStyle
      ctx.fillStyle = color

      //Draw text in center
      ctx.fillText(txt, centerX, centerY)
    }
  }
})

export default {
  extends: Pie,
  props: ['chartData', 'colors', 'configs'],
  mounted() {
    this.rerender()
  },
  methods: {
    rerender() {
      const chart = this.chartData
      if (chart.colors) {
        let backgroundColor = [],
          borderColor = []

        chart.datasets[0].title.forEach(title => {
          for (let key in chart.colors) {
            if (key === title) {
              backgroundColor.push(`rgba(${chart.colors[key]}, .2)`)
              borderColor.push(`rgba(${chart.colors[key]}, 1)`)
            }
          }
        })

        Object.assign(chart.datasets[0], {
          backgroundColor,
          borderColor,
          borderWidth: 1
        })
      } else {
        chart.datasets.forEach((el, i) => {
          let borderColor = el.borderColor ? el.borderColor : null
          let backgroundColor = el.backgroundColor ? el.backgroundColor : null
          if (backgroundColor) {
            Object.assign(el, {
              backgroundColor,
              borderColor: borderColor ? borderColor : backgroundColor,
              borderWidth: 1
            })
            return
          }
          let color = el.color
            ? el.color
                .replace('rgb(', '')
                .replace('rgb(', '')
                .replace(')', '')
            : settingsColors[i]
          if (!color) {
            const [R, G, B] = [
              Math.floor(Math.random() * 255),
              Math.floor(Math.random() * 255),
              Math.floor(Math.random() * 255)
            ]
            color = `${R}, ${G}, ${B}`
          }
          borderColor = settingsColors.map(color => {
            return `rgba(${color}, 1)`
          })
          backgroundColor = settingsColors.map(color => {
            return `rgba(${color}, .2)`
          })

          Object.assign(el, {
            backgroundColor,
            borderColor,
            borderWidth: 1
          })
        })
      }
      const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: this.configs.parameters['Legend position'],
          display: this.configs.parameters['Legend position'] != 'off'
        } // ,
        // title: {
        //   display: this.configs.parameters['Display title'],
        //   text: this.configs.name
        // }
      }
      this.renderChart(chart, options)
    }
  },
  watch: {
    configs: {
      deep: true,
      handler: 'rerender'
    }
  }
}
</script>
<style lang="scss">
.dashboard-widget > div {
  width: 100% !important;
  height: 100% !important;
}
</style>
